import React, { useContext } from 'react';
import { NotificationsTray } from '@fullstory/tomato-components';

export const NotificationsContext = React.createContext<NotificationsTray | null>(null);

export const useNotifications = () => {
  const notifications = useContext(NotificationsContext);

  if (notifications == null) {
    throw new Error(
      'useNotifications requires a NotificationsTray to be provided. Are you missing a <NotificationsContext.Provider />?',
    );
  }

  return notifications;
};
